<template>
  <div class="home" v-loading.fullscreen.lock="loading">
    <div class="home_list">
      <div class="home_list_item" v-for="item in declareList" :key="item.id" v-show="item.enable_mark === 1">
        <!-- <h3>{{item.project_name}}<span v-if="item.kslb ==='sczyps'">(报名已结束)</span></h3> -->
        <h3>{{item.project_name}}<span v-if="!(isDuringDate(item.starTime, item.endTime))">(报名已结束)</span></h3>
        <div class="time">
          <span>报名时间:</span>
          {{item.starTime}} ~ {{item.endTime}}
        </div>
        <div class="home_content">
          <p class="contentTxt" v-html="item.notes"></p>
          <a class="ckqw" target="_blank" @click="seeView(item)">...&nbsp;[查看全文]</a>
        </div>
        <div class="state">
          <Button ghost  class="manual_btn" v-if="item.kslb ==='sczyps' && item.zy_room_id" @click="printZKZ(item)">打印准考证</Button>
          <!-- <Button ghost  class="manual_btn" v-if="item.kslb ==='sczyps'"  @click="printCNS(item)">打印考生防疫情况承诺书</Button> -->
          <a class="manual_btn" target="_blank" v-if="item.kslb ==='sczyps'" href="http://202.61.89.90:8080/ksbm/%E4%B8%AD%E5%8C%BB%E5%B8%88%E6%89%BF%E4%B8%AA%E4%BA%BA%E7%94%B3%E6%8A%A5%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E.pdf">操作手册</a>
          <Button ghost @click="sbxxtxClick(item)" v-if="!item.project_state">申报信息填写</Button>
          <Button ghost :to="{name:'speedQuery',params:{code:item.project_code}}" v-if="item.project_state">进度查询</Button>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less">
.home {
  height: 100%;
  width: 1200px;
  margin: 0 auto;
  .home_list_item {
    padding: 15px 0;

    h3 {
      width: 100%;
      height: 30px;
      font-size: 24px;
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #333333;
      span{
        font-weight: normal;
        font-size: 16px;
        color: #00b49b;
        margin-left: 10px;
      }
    }

    .time {
      font-size: 12px;
      color: #00b49b;
      height: 30px;
      border-bottom: 1px solid #dddddd;
      margin: 10px 0;
      span {
        color: #555555;
        font-size: 12px;
      }
    }
    .home_content {
      position: relative;
      .ckqw {
        position: absolute;
        right: 0px;
        bottom: -2px;
        padding: 0px 0 0 5px;
        background: #f5f5f5;
        color: #00b49b;
      }
    }
    .contentTxt {
      font-size: 14px;
      height: 100px;
      overflow: hidden;
      color: #777777;
    }

    .state {
      margin-top: 15px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      .manual_btn {
        color: #00b49b;
        border: 1px solid #00b49b;
        color: #00b49b;
        padding-top: 0.1px;
        line-height: 30px;
        display: inline-block;
        margin-bottom: 0;
        font-weight: 400;
        text-align: center;
        vertical-align: middle;
        touch-action: manipulation;
        cursor: pointer;
        height: 32px;
        padding: 0 15px;
        font-size: 14px;
        border-radius: 4px;
        margin: 0 5px;
      }
      .ivu-btn {
        border-color: #00b49b;
        color: #00b49b;
      }
    }
  }
}
</style>
<script>
import { DeclareList, DeclareListState, print } from "@/api/declare/index";
import util from "@/libs/util";
export default {
  data() {
    return {
      loading: false,
      declareList: []
    };
  },
  mounted() {
    this.getDeclareList();
  },
  methods: {
    //获取申报项目列表
    getDeclareList() {
      this.loading = true;
      let params = {
        pagesize: 10,
        pageIndex: 1
      };
      DeclareList(params)
        .then(res => {
          let dataArr = new Array();
          for (let i = 0; i < res.items.length; i++) {
            let prjCode = (res.items[i].project_code).substring(0,(res.items[i].project_code).length-4);
            let objsNew = res.items[i];
            objsNew.starTime = util.tool.dateFormat(
              "yyyy-MM-dd",
              new Date(res.items[i].project_start_date)
            );
            objsNew.endTime = util.tool.dateFormat(
              "yyyy-MM-dd",
              new Date(res.items[i].project_end_date)
            );
            objsNew.kslb = prjCode;
            dataArr.push(objsNew);
          }

          this.declareList = dataArr;
          console.log(this.declareList)
          this.getDeclareListState(dataArr);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //根据项目code匹配项目申报状态
    getDeclareListState(dataArr) {
      let params = {
        user_id: util.storage.getUserInfo().obj_id
      };
      DeclareListState(params)
        .then(res => {
          for (let i = 0; i < dataArr.length; i++) {
            for (let j = 0; j < res.length; j++) {
              if (dataArr[i].project_code == res[j].project_code) {
                this.$set(this.declareList[i], "project_state", true);
                this.$set(this.declareList[i], "auditMainId", res[j].id);
                this.$set(this.declareList[i], "zy_room_id", res[j].zy_room_id);
              }
            }
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 查看全文
    seeView(item){
      if (item.herf_url) {
        window.open(item.herf_url);
      }
    },
    // 申报信息填写
    sbxxtxClick(item) {
      if (item.project_cur_step == 0) {
        this.$Modal.error({
          title: "提醒",
          content: "报名时间未开始！"
        });
      } else if (item.project_cur_step != 10) {
        this.$Modal.error({
          title: "提醒",
          content: "报名时间已截止！"
        });
      } else {
        let prjCode = (item.project_code).substring(0,(item.project_code).length-4);
        if(prjCode === "sczyps"){
          this.$router.push({
            name: "declare",
            params: {
              id: item.project_code
            }
          });
        }else if(prjCode === "sczykh"){
          this.$router.push({
            name: "declares",
            params: {
              id: item.project_code
            }
          });
        }
      }
    },
    // 判断现在时间是否在某一时间范围内
    isDuringDate(beginDateStr, endDateStr) {
      var curDate = new Date(),
            beginDate = new Date(beginDateStr),
            endDate = new Date(endDateStr);
        if (curDate >= beginDate && curDate <= endDate) {
            return true;
        }
        return false;
    },

    printZKZ(item) {
      let downloadUrl = process.env.VUE_APP_BASE_URL+'/webapi/api/auditmain/export_exam_ticket_zyys?auditMainId='+item.auditMainId +'&access_token='+util.cookies.get('token');
      let a = document.createElement("a");
      a.setAttribute("href", downloadUrl);
      a.setAttribute("target", "_blank");
      a.setAttribute("id", "startTelMedicine");
      // 防止反复添加
      if (document.getElementById("startTelMedicine")) {
        document.body.removeChild(
          document.getElementById("startTelMedicine")
        );
      }
      document.body.appendChild(a);
      a.click();
    },

    printCNS() {
      window.open('http://202.61.89.90:8080/ksbm/%E8%80%83%E7%94%9F%E9%98%B2%E7%96%AB%E6%83%85%E5%86%B5%E6%89%BF%E8%AF%BA%E4%B9%A6.docx')
    }
  }
};
</script>